
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/addresses",
      function () {
        return require("private-next-pages/user/addresses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/addresses"])
      });
    }
  